import { atom } from "recoil";

import { AccountAdapter } from "../adapters/account";
import { IAccount } from "../types/account";

export const userAtom = atom<IAccount>({
  key: "userAtom",
  default: AccountAdapter.toModel({}),
});
